// extracted by mini-css-extract-plugin
export default {"container":"FeedbackBanner_container__jLvJV","content-row":"FeedbackBanner_content-row__l50Nk"};